/*
 * Copyright (c) Schrocken Inc.
 * Author: Nitin
 * File Description: Sign Up components
 */

import React from 'react';

import SignUpSteps from './SignUpSteps';

import HeaderFooter from '../../common/openPages/HeaderFooterwithCookies';

const SignUp = () => {
  return (
    <HeaderFooter cookiesEnabled>
      <SignUpSteps />
    </HeaderFooter>
  );
};

export default SignUp;
